<template>
  <div class="barcode-scanner-page">
    <h2>手机扫 - 条形码扫描器</h2>

    <!-- 自己的任务选择 -->
    <el-select
        v-model="taskId"
        placeholder="请选择出库任务"
        style="margin-bottom: 20px; width: 300px;"
        @change="onTaskChange"
    >
      <el-option
          v-for="item in cktaskList"
          :key="item.id"
          :label="item.name"
          :value="item.id"
      />
    </el-select>

    <!-- 自己的设备列表 -->
    <div class="device-section" v-if="taskId">
      <h4 class="section-title">设备出库进度</h4>
      <el-table
          :data="deviceList"
          border
          stripe
          style="width: 100%"
          height="400"
      >
        <el-table-column prop="code" label="设备" min-width="180" show-overflow-tooltip>
          <template slot-scope="scope">
            {{ formatepid(scope.row.pid) }}
          </template>
        </el-table-column>
        <el-table-column prop="num" label="应出" width="120" align="center" />
        <el-table-column prop="state" label="已出" width="120" align="center">
          <template slot-scope="scope">
            <span :class="{ 'out-highlight': scope.row.state >= scope.row.num }">
              {{ scope.row.state || 0 }}
            </span>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="scanner-wrapper">
      <div id="reader" class="reader-container"></div>
      <div class="scan-overlay" v-if="scanning">
        <div class="scan-line horizontal"></div>
      </div>
    </div>

    <div class="controls">
      <el-button
          type="primary"
          :disabled="scanning || !cameras.length"
          @click="startScanning"
      >
        开始扫描
      </el-button>

      <el-button
          type="danger"
          :disabled="!scanning"
          @click="stopScanning"
      >
        停止扫描
      </el-button>

      <el-button
          type="info"
          @click="switchCamera"
          :disabled="!cameras.length || cameras.length <= 1"
      >
        切换摄像头
      </el-button>
    </div>

    <div class="status" v-if="statusMessage">{{ statusMessage }}</div>

    <el-alert
        v-if="errorMessage"
        title="错误"
        type="error"
        :description="errorMessage"
        show-icon
        :closable="true"
        @close="errorMessage = ''"
    />
  </div>
</template>

<script>
import { Html5Qrcode } from 'html5-qrcode'

export default {
  data() {
    return {
      scanning: false,
      cameras: [],
      currentCameraId: null,
      statusMessage: '',
      errorMessage: '',

      // 独立的数据，和扫码枪 tab 一样
      taskId: undefined,
      cktaskList: [],
      deviceList: [],
      productList: []  // 用于 formatepid
    }
  },

  mounted() {
    this.gettask()
    this.getproductList()
    this.initScanner()
  },

  beforeDestroy() {
    this.stopScanning()
  },

  methods: {
    // 加载任务列表（和扫码枪一样）
    gettask() {
      this.$request.postHttp({
        url: "/basic/getcktask",
        success: (data) => {
          this.cktaskList = data.data || []
        },
        error: (error) => {
          console.error("获取任务失败:", error)
        }
      })
    },

    // 加载商品列表（用于显示设备名称）
    getproductList() {
      this.$request.postHttp({
        url: "/basic/getsp",
        success: (data) => {
          this.productList = data.data || []
        },
        error: (error) => {
          console.error("Error:", error)
        }
      })
    },

    // 任务切换时加载设备列表
    onTaskChange() {
      if (!this.taskId) return
      this.getdeviceList()
    },

    // 加载设备列表
    getdeviceList() {
      this.$request.getHttp({
        url: "/basic/getckinfo",
        params: { id: this.taskId },
        success: (data) => {
          this.deviceList = data.data || []
        },
        error: (error) => {
          console.error("加载设备列表失败:", error)
        }
      })
    },

    formatepid(pid) {
      const found = this.productList.find(item => item.id == pid)
      return found ? found.name : '--'
    },

    // 扫描相关方法保持不变，但 onScanSuccess 只处理请求 + 刷新
    async initScanner() {
      // ... 原有代码不变 ...
    },

    async startScanning() {
      // ... 原有代码不变 ...
    },

    async stopScanning() {
      // ... 原有代码不变 ...
    },

    async switchCamera() {
      // ... 原有代码不变 ...
    },

    onScanSuccess(decodedText) {
      const barcode = decodedText.trim()

      if (!barcode || barcode.length < 6) return

      this.stopScanning()

      if (!this.taskId) {
        this.statusMessage = '请先选择出库任务'
        return
      }

      this.handleBarcodeResult(barcode)
    },

    async handleBarcodeResult(barcode) {
      this.statusMessage = '处理中...'

      this.$request.postHttp({
        url: "/basic/ckOrder",
        params: { id: this.taskId, bm: barcode },

        success: () => {
          // 不处理任何返回消息
          this.getdeviceList()  // 刷新自己的列表
          this.statusMessage = '已处理，列表已刷新'
        },

        error: (err) => {
          console.error('出库请求失败', err)
          this.getdeviceList()  // 即使失败也刷新（可根据需要去掉）
          this.statusMessage = '处理完成，列表已刷新'
        }
      })
    },

    onScanFailure() {
      // 忽略
    }
  }
}
</script>

<style scoped>
/* 原有样式保持不变，新增一点设备列表样式 */
.device-section {
  margin-bottom: 30px;
}

.section-title {
  margin: 0 0 12px;
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

.barcode-scanner-page {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
}

/* 其他样式保持原样 */
</style>